
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Clock } from "lucide-react";

export const QuietHours = () => {
  return (
    <RegulationItem 
      value="quiet-hours" 
      icon={Clock}
      iconColor="text-blue-600"
      title="Quiet Hours"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Quiet hours are in effect from 10pm-7am.</li>
        <li>Please be respectful of other campers during these hours.</li>
        <li>Loud music, voices, and other disruptive noises should be kept to a minimum.</li>
        <li>Generators should not be operated during quiet hours.</li>
      </ul>
    </RegulationItem>
  );
};
